export const GET_DISABLED_REPORT_XLSX = 'GET_DISABLED_REPORT_XLSX';
export const GET_DISABLED_REPORT_CSV = 'GET_DISABLED_REPORT_CSV';
export const GET_DISABLED_REPORT_PDF = 'GET_DISABLED_REPORT_PDF';
export const GET_DISABLED_REPORT_PAGINATED = 'GET_DISABLED_REPORT_PAGINATED';
export const SET_DISABLED_REPORT_PAGINATION = 'SET_DISABLED_REPORT_PAGINATION';
export const SET_DISABLED_REPORT_FILTERS = 'SET_DISABLED_REPORT_FILTERS';
export const RESET_DISABLED_REPORT = 'RESET_DISABLED_REPORT';



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/constants/reports_disabled_constants.js